import { type } from "@testing-library/user-event/dist/type";
import { types } from "../types/types";

const initialState = {
    isLoading : true,
    timings: [],
    searchTiming: [],
    timingActive:null,
    //ID del Driver especifico del timing. Para extender su turno
    driverOnlyTiming: null
}

export const timingReducer = ( state=initialState, action ) => {
    
    switch ( action.type ) {
        case types.getTiming:
            return {
                ...state,
                timings:  action.payload 
            }
        case (types.getTimingSearch):
            return {
                ...state,
                searchTiming: [ action.payload ]
            }
        case types.isLoadingTiming:
            return {
                ...state,
                isLoading: action.payload
            }
        case types.timingActive:
            return{
                ...state,
                timingActive:action.payload
            }
        case types.driverTimingOnly:
            return{
                ...state,
                driverOnlyTiming: action.payload
            }
        default:
            return state;
    }
}

